var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cta-card-anfitriao p-card rounded shadow-sm m-auto",class:_vm.isMobile ? 'isMobile' : ''},[_c('h2',{staticClass:"h4 text-white"},[_vm._v("Seja Anfitrião de Bikes")]),_c('el-button',{staticClass:"font-weight-bold mt-1 mb-2",attrs:{"type":"secondary","size":"medium"},on:{"click":_vm.goToBlog}},[_vm._v(" Saiba mais ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }